import { Component} from '@angular/core';
import { NavController, ModalController, Platform, NavParams, ViewController } from 'ionic-angular';
import {AngularFireDatabase,  FirebaseListObservable, FirebaseObjectObservable} from 'angularfire2/database';
import {Question} from '../../models/user';
import {AngularFireAuth} from 'angularfire2/auth';
@Component({
  selector: 'modal-page',
  templateUrl: 'modal.html'
})
export class ModalContentPage {

  question;

  data = {} as Question;

  update: FirebaseObjectObservable<any[]>;
  newv: FirebaseListObservable<any[]>

  constructor(private afauth: AngularFireAuth, private db: AngularFireDatabase, public platform: Platform, public params: NavParams, public viewCtrl: ViewController) {
    const authObserver = afauth.authState.subscribe( user => {
      if (user )
      {
          if(this.params.get('ques'))
          {
            this.question = this.params.get('ques');
            this.update = db.object('/questions/' + this.question.$key);
          }
          else
          {
              this.newv = db.list('/questions/');
          }

        }})


  }

  dismiss() {
    this.viewCtrl.dismiss();
  }
 
  goSave()
  {
    this.update.set({question: this.data.question, correct: this.data.correct, cat: this.data.cat,
      answers: {
        0: this.data.answers0 ? this.data.answers0 : null,
        1 : this.data.answers1 ? this.data.answers1 : null,
        2: this.data.answers2 ? this.data.answers2 : null,
        3 : this.data.answers3 ? this.data.answers3 : null,
        4: this.data.answers4 ? this.data.answers4 : null,
        5 : this.data.answers5 ? this.data.answers5 : null}
      });
    this.viewCtrl.dismiss();

  }

  goAdd()
  {
    this.newv.push({question: this.data.question, correct: this.data.correct, cat: this.data.cat,
      answers: {
        0: this.data.answers0 ? this.data.answers0 : null,
        1 : this.data.answers1 ? this.data.answers1 : null,
        2: this.data.answers2 ? this.data.answers2 : null,
        3 : this.data.answers3 ? this.data.answers3 : null,
        4: this.data.answers4 ? this.data.answers4 : null,
        5 : this.data.answers5 ? this.data.answers5 : null}
      });
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/modal.ts